module.exports = __webpack_public_path__ + "static/media/wine-512.ea283330.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wine-512.png
// module id = 789
// module chunks = 0